import { MakeUrlProps, MakeUrlResult } from './';

export function makeUrl(props: MakeUrlProps): MakeUrlResult {
  const { url } = props;

  const queryParameters = url.queryParameters ? `?${url.queryParameters}` : '';
  if (url.urlDestination === 'void') return '/';
  if (url.urlDestination === 'external')
    return `${url.externalLink}${queryParameters}`;
  return `/${url.url}`;
}
